import joi from 'joi';
import { dateDefault } from './types.def';

export const department = joi.object({
	schema: joi.string(),
	id: joi.string(),
	url: joi.string(),
	name: joi.string(),
	createdAt: dateDefault,
	updatedAt: dateDefault,
	org: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	tokens: joi.array().items(joi.string()),
});
